
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import supInfoApprove from '@/page/supplier/approval/sup-info-approve';
import requisitionSapFlow from '@/page/requisition-sap-flow/requisition-sap-flow';
import newSupApproval from '@/page/supplier/approval/new-sup-approval';
import supGoodsDetail from '@/page/supplier/goods/sup-goods-detail';
import sourceItemApproval from '@/page/sources/source-item/source-item-approval';
import priceApprovalCheck from '@/page/price-approval/price-approval-check';
import purchaseOrderCheck from '@/page/purchase-order/purchase-order-check';
import purchaseOrderApproveCheck from "@/page/purchase-order/purchase-order-approve-check";
import LeaveMessageCheck from "@/page/leave-message/leave-message-check";
import LeaveMessageEdit from "@/page/leave-message/leave-message-edit";
import purRequisitionCheck from '@/page/purchase-requisition/pur-requisition-check';
import supAssFlow from '@/page/supplier-assess/sup-ass-flow';
import contractView from '@/page/contract/contract-view';
import supAssRead from '@/page/supplier-assess/sup-ass-read';
import receiptView from '@/page/receipt/receipt-view';
import soaView from '@/page/soa/soa-view';
import ClaimManagementView from "../claim-management/claim-management-view";
import ScoreApproval from  "@/page/sources/source-score/score-approval";
import BookVehicle from '@/page/supplier/view/book-vehicle';
import RedundancyAllocation from '@/page/purchase-requisition/redundancy-allocation'
import { isWx, closeWX } from '@/utils';

/**
* formData为工作流表单，valid()为工作流表单校验方法
* */
export default {
name: "workflow",
directives: {
TransferDom
},
components: {
ClaimManagementView,
LeaveMessageCheck,
LeaveMessageEdit,
ButtonTab,
ButtonTabItem,
PopupHeader,
Popup,
supInfoApprove,
requisitionSapFlow,
newSupApproval,
supGoodsDetail,
sourceItemApproval,
priceApprovalCheck,
purchaseOrderCheck,
purchaseOrderApproveCheck,
purRequisitionCheck,
supAssFlow,
supAssRead,
contractView,
soaView,
receiptView,
ScoreApproval,
BookVehicle,
RedundancyAllocation,
},
data() {
return {
token: null,
principalPersonId: null,
requestId: null,
workflowId: null,
imgBaseUrl: process.env.API_ROOT,
headUrl: require('../../assets/icon/touxiang.png'),
componentList: {
reform: ['SupplierReformViewComponent', 'SupplierReformDrawerComponent'],
sample: ['CertificationViewComponent', 'SampleComponentDrawerComponent'],
},
dataId: null,
title: null,
actNodeId: null,
editable: null,
processFlow: {},
current: {},
approvalShow: false,
approvalText: null,
componentForm: null,
initComponentForm: null,
operationList: [],
backNodeList: [],
backNodeBol: false,
showFlowInfo: false,
bigImg: false,
noticeList: [
{component: 'ContractViewComponent', nodeName: '发起'},
{component: 'ViewOrderDetailComponent', nodeName: '采购员'},
],
orderNo: null,
singleWorkflow: false,
forwardId: null,
ccId: null,
supervisionId: null
}
},
methods: {
backLastPage() {

if (isWx && window.history && window.history.length <= 1) {
closeWX()
}
if (this.$store.state.device === 'wap') {
if (this.singleWorkflow) {
this.$router.replace('/');
} else {
this.$router.go(-1);
}
} else {
document.location = "http://action:10002/?";
}
},
/**
* 根据requestId获取相应数据
* */
initWorkflowData(data) {
if (data && data.data) {
this.dataId = data.data.dataId;
if (data.data.title && !this.title) {
this.title = data.data.title;

}
this.editable = data['data'].editable;
this.current = data['data'];
console.log("3333333333333", this.current)
this.workflowId = data['data'].workflowId;
this.actNodeId = data['data'].workflowNodeBase.actNodeId;
this.workflowNodeBaseId = data['data'].workflowNodeBase.id;
this.backImg();
this.initData(data);
if (this.editable && data.data.workflowFormBase) {
this.componentForm = data.data.workflowFormBase.formUrl;
console.log(this.componentForm);
this.componentForm = this.componentForm.split('>').length > 1 ? this.componentForm.split('>')[1] : this.componentForm.split('>')[0];
this.replacePc();
} else {
this.componentForm = data.data.workflowFormBase.readFormUrl;
console.log(this.componentForm);
this.componentForm = this.componentForm.split('>').length > 1 ? this.componentForm.split('>')[1] : this.componentForm.split('>')[0];
this.replacePc();
}
if (data.data.workflowButtonList) {
for (let i = 0; i < data.data.workflowButtonList.length; i++) {
if (i === 0 && data.data.workflowButtonList[i].enable) {
let item = {
key: 'commit',
label: '提交'
};
this.operationList.push(item);
}







else if (i === 2 && data.data.workflowButtonList[i].enable) {
let item = {
key: 'back',
label: '退回'
};
this.getBackNodeList();
this.operationList.push(item);
}
}
}
}
},

addPrincipalPersonId(data) {
if (this.principalPersonId) {
data.principalPersonId = this.principalPersonId;
}
},

getWorkFlowInfo() {
this.$loadingShow();
const that = this;
const obj = { requestId: this.requestId };
that.$get('api/workflowRequest/requestView', {requestId: that.requestId}).then((res) => {
that.$loadingHide();
if (res === true || res.immediateView === true || res.principalPersonId) {
that.$loadingShow();
if (res && res.principalPersonId) {
that.principalPersonId = res.principalPersonId;
}

that.addPrincipalPersonId(obj);
that.$get('api/workflowRequest/request', obj).then((data) => {
that.$loadingHide();
console.log("11111x",data)
that.initWorkflowData(data);
}).catch(err => that.$loadingHide())
} else if (res.ccId) {
that.ccId = res.ccId;
that.openCcByCcid();
} else if (res.forwardId) {
that.forwardId = res.forwardId;
that.openByForwardId();
} else if (res.monitorView) {
that.openMonitorByRequestId();
} else if (res.supervisionId) {
that.supervisionId = res.supervisionId;
that.openSupervisionBySupervisionid();
} else {
if (!that.initComponentForm) {
that.$vux.toast.text('暂无查看权限');
} else {
that.componentForm = that.initComponentForm;
that.componentForm = that.componentForm.split('>').length > 1 ? that.componentForm.split('>')[1] : that.componentForm.split('>')[0];
}
that.$loadingShow()
that.$get('api/workflowRequest/requestBusiness', {requestId: that.requestId}).then((data) => {
that.$loadingHide()
if (data && data.data) {
that.dataId = data.data.dataId;
if (data.data.title && !that.title) {
console.log("22222")
that.title = data.data.title;

}
that.editable = data['data'].editable;
that.current = data['data'];
that.workflowId = data['data'].workflowId;
console.log("222222222222222222", that.current)
}
that.processFlow.nodeName = data['data'].workflowNodeBase.nodeName;
that.processFlow.lastName = data['data'].lastOperatorName;
that.backImg();
}).catch(err => that.$loadingHide())
}
}).catch(err => that.$loadingHide())
},
initData(data) {
if (data['data'].workflowBase != null) {
this.processFlow.linkFile = data['data'].workflowBase.linkFile; 
this.processFlow.linkFlow = data['data'].workflowBase.linkFlow; 
this.processFlow.confirm = data['data'].workflowBase.confirm; 
this.processFlow.showDiagram = data['data'].workflowBase.showDiagram; 
}
this.processFlow.nodeName = data['data'].workflowNodeBase.nodeName; 
this.processFlow.remark = data['data'].remark; 
this.editable = data['data'].editable; 
this.processFlow.lastName = data['data'].lastOperatorName;
this.processFlow.detailBtn = data['data'].workflowNodeBase.startNode; 
this.processFlow.requestId = data['data'].requestId; 
if (this.editable == true) {
this.processFlow.forWard = data['data'].workflowButtonList[3].enable;  

this.processFlow.transfer = data['data'].workflowButtonList[4].enable;  
} else {
this.processFlow.forWard = false;  

this.processFlow.transfer = false;  
}
},
/**
* 发起流程时根据流程id获取相应数据
* */
getWorkFlowInfoInit() {
this.processFlow.detailBtn = false;
this.processFlow.transfer = false; 
this.processFlow.forWard = false; 
this.editable = true;
this.$get(`api/workflowRequest/startWorkflow/?workflowId=${this.workflowId}`).then((data) => {
this.processFlow.lastName = null;
this.processFlow.linkFlow = data.workflowBase.linkFlow;
this.processFlow.nodeName = data.workflowNodeBase.nodeName;
this.processFlow.deploymentId = data.workflowBase.deploymentId;
this.processFlow.confirm = data.workflowBase.confirm; 
this.processFlow.showDiagram = data.workflowBase.showDiagram; 
if (this.editable && data.workflowFormBase) {
this.componentForm = data.workflowFormBase.formUrl;
this.componentForm = this.componentForm.split('>').length > 1 ? this.componentForm.split('>')[1] : this.componentForm.split('>')[0];
} else {
this.componentForm = data.workflowFormBase.readFormUrl;
this.componentForm = this.componentForm.split('>').length > 1 ? this.componentForm.split('>')[1] : this.componentForm.split('>')[0];
}
this.operationList = [{
key: 'commit',
label: '提交'
}, {
key: 'save',
label: '保存'
}];
this.backImg();
})

},
/**
* 获取流程图
*/
backImg() {

if (!this.processFlow.deploymentId) {
this.processFlow.deploymentId = '';
}
let ImgObj = {deploymentId: this.processFlow.deploymentId, requestId: this.requestId};
let imgData = '';
for (let key in ImgObj) {
imgData += '&' + key + '=' + ImgObj[key];
}
imgData = imgData.slice(1);
imgData = '?' + imgData;
this.processFlow.dataImg = process.env.API_ROOT + 'api/act/resource/read/' + imgData;
},
showApproval() {
this.approvalText = null;
this.approvalShow = true;
this.$refs.workflowForm && this.$refs.workflowForm.beforeValid && this.$refs.workflowForm.beforeValid((result) => {
if (!result) {
this.cancelApproval();
}
})
},


cancelApproval() {
this.approvalShow = false;
},

operation(item,operation) {
console.log(item,operation,"12121212")
if (item) {
if (item.key === 'commit') {
this.submitApproval();
} else if (item.key === 'save') {
this.saveApproval();
} else if (item.key === 'back') {
this.backNodeBol = true;
}
}
},

submitApproval() {
if (this.$refs.workflowForm && this.$refs.workflowForm.valid()) {
let workflowObj = {
param: this.$refs.workflowForm.formData(),
requestId: this.requestId,
workflowId: this.workflowId,
workflowNodeBaseId: this.workflowNodeBaseId,
workflowRequestLog: {
remark: this.approvalText,
},
};

if (this.principalPersonId) {
workflowObj.principalPersonId = this.principalPersonId;
}
this.$loadingShow();
this.$post('api/workflowRequest/commit', workflowObj).then((res) => {
if (res.status == 0) {
this.$vux.toast.text('提交成功');
if (!this.requestId && res.data && res.data.requestId) {
this.requestId = res.data.requestId;
}
if (this.requestId) {
this.getWorkFlowInfo();
}
this.backLastPage();
} else {
this.$vux.toast.text(res.message);
}
this.$loadingHide();
}).catch(() => {
this.$loadingHide();
})
}
},


saveApproval() {
if (this.$refs.workflowForm && this.$refs.workflowForm.valid()) {
let workflowObj = {
param: this.$refs.workflowForm.formData(),
requestId: this.requestId,
workflowId: this.workflowId,
workflowNodeBaseId: this.workflowNodeBaseId,
workflowRequestLog: {
remark: this.approvalText,
},
};
this.$loadingShow();
this.$post('api/workflowRequest/save', workflowObj).then((res) => {
if (res.status == 0) {
this.$vux.toast.text('保存成功');
if (this.requesetId) {
this.getWorkFlowInfo();
}
this.backLastPage();
} else {
this.$vux.toast.text(res.message);
}
this.$loadingHide();
}).catch(() => {
this.$loadingHide();
})
}
},

backNode(key, item) {
if (item) {
let that = this;
this.$vux.confirm.show({
title: '确认退回',
onConfirm() {
let workflowObj = {
param: that.$refs.workflowForm.formData(),
nodeId: item.id,
requestId: that.requestId,
workflowId: that.workflowId,
workflowRequestLog: {
remark: that.approvalText,
},
};

if (that.principalPersonId) {
workflowObj.principalPersonId = that.principalPersonId
workflowObj.submitDirectToBackNode = that.submitDirectToBackNode
}
that.$loadingShow();
that.$post('api/workflowRequest/requestRollbackAll', workflowObj).then((res) => {
if (res.status == 0) {
that.$vux.toast.text('退回成功');
that.getWorkFlowInfo();
that.backLastPage();
} else {
that.$vux.toast.text(res.message);
}
that.$loadingHide();
}).catch(() => {
that.$loadingHide();
})
}
})
}
},
/**
* 获取回退节点
*/
getBackNodeList() {
let params = {requestId: this.requestId, workflowId: this.workflowId, dataId: this.dataId};
this.$get('api/workflowRequest/historyTask', params).then((res) => {
res.forEach((item) => {
item.label = item.nodeName;
this.backNodeList.push(item);
})
})
},

showFlowMet(bol) {
this.showFlowInfo = bol;
},

replacePc() {
if (this.componentForm === 'WorkflowDynamicFormValueComponent') {
let baseUrl;
if (this.$store.state.systemConfig) {
baseUrl = this.$store.state.systemConfig.systemUrl + '#/';
} else {
return;
}
this.$store.dispatch('commitChangeIframeUrl', `${baseUrl}jy-sso?token=${this.token}&requestId=${this.requestId}&isMobile=1`);
this.$router.replace('/dynamic-flow');
}
},
/**
* 转发逻辑处理
* */
openByForwardId() {
this.$loadingShow();
this.$get(`api/workflowRequest/requestForward/${this.forwardId}`).then((data) => {
this.$loadingHide();
console.log("222222x")
this.initWorkflowData(data);
}).catch(err => this.$loadingHide())
},
/**
* 抄送逻辑处理
* */
openCcByCcid() {
this.$loadingShow();
this.$get(`api/workflowRequest/requestCc/${this.ccId}`).then((data) => {
this.$loadingHide();
console.log("33333x")
this.initWorkflowData(data);
}).catch(err => this.$loadingHide());
},
/**
* 督办逻辑处理
* */
openSupervisionBySupervisionid() {
this.$loadingShow();
this.$get(`api/workflowRequest/requestSupervision/${res.supervisionId}`).then((data) => {
this.$loadingHide();
console.log("44444x")
this.initWorkflowData(data);
}).catch(err => this.$loadingHide())
},
/**
* 监控逻辑处理
* */
openMonitorByRequestId() {
this.$loadingShow();
this.$post('api/workflowMonitor/requestMonitor', {requestId: this.requestId}).then((data) => {
this.$loadingHide();
console.log("55555x")
this.initWorkflowData(data);
}).catch(err => this.$loadingHide());
}
},
mounted() {
if (this.$route.path.indexOf('single-workflow') > -1) {
this.singleWorkflow = true;
}
let tokens = localStorage.getItem('_token');
if (tokens) {
this.token = tokens.substr(7);
}
if (this.$route.meta.type === 'forward') {
this.forwardId = this.$route.params.forwardId;
this.openByForwardId();
} else if (this.$route.meta.type === 'cc') {
this.ccId = this.$route.params.ccId;
this.openCcByCcid();
} else if (this.$route.meta.type === 'supervision') {
this.supervisionId = this.$route.params.supervisionId;
this.openSupervisionBySupervisionid();
} else if (this.$route.meta.type === 'monitor') {
this.requestId = this.$route.params.requestId;
this.openMonitorByRequestId();
} else {
if (this.$route.params.requestId === 'initiate') {
this.requestId = null;
} else {
this.requestId = this.$route.params.requestId;
}
if (!this.requestId) {
this.getWorkFlowInfoInit();
} else {
this.getWorkFlowInfo();
}
}
if (this.$route.query.component) {
this.initComponentForm = this.$route.query.component;
}
if (this.$route.query.workflowId) {
this.workflowId = this.$route.query.workflowId;
}
if (this.$route.query.title) {
console.log("333333")
this.title = this.$route.query.title;

}
if (this.$route.query.orderNo) {
this.orderNo = this.$route.query.orderNo;
}
},
watch: {
$route() {
this.dataId = null;
this.title = null;
if (this.$route.params.requestId === 'initiate') {
this.requestId = null;
} else {
this.requestId = this.$route.params.requestId;
}
if (this.$route.query.component) {
this.initComponentForm = this.$route.query.component;
}
if (this.$route.query.workflowId) {
this.workflowId = this.$route.query.workflowId;
}
if (this.$route.query.title) {
console.log("4444444")
this.title = this.$route.query.title;


}
if (this.$route.query.orderNo) {
this.orderNo = this.$route.query.orderNo;
}
if (!this.requestId) {
this.getWorkFlowInfoInit();
} else {
this.getWorkFlowInfo();
}
}
}
}



// WEBPACK FOOTER //
// ./src/page/flow/workflow.vue